<div style="background-color: #fff">
  <!-- <div style="background-color: #F5F5F5;"> -->
  <h2>Preview</h2>
  <div style="display: flex; justify-content: space-between; align-items: center">
    <div style="display: flex; flex-direction: column; flex: 1 1 100%; max-width: 49%">
      <div style="background-color: #f9ecff; width: 162px; height: 30px">
        <span style="color: #5f177f; vertical-align: sub; padding-left: 8px; font-family: 'Open Sans'; font-size: 16px">
          CURRENT VERSION
        </span>
      </div>
      <vng-card>
        <div class="preview-fields-row">
          <vng-input
            label="FlyCut"
            placeholder="FlyCut"
            style="flex: 1 1 100%; max-width: 30%"
            type="text"
            [(ngModel)]="currentFlyCut.shortcut"
            name="search"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          ></vng-input>

          <vng-input
            label="Title/Description"
            placeholder="Title/Description"
            style="flex: 1 1 100%; max-width: 70%"
            type="text"
            [(ngModel)]="currentFlyCut.title"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          ></vng-input>
        </div>

        <hr style="width: 100%; margin-left: 0" />
        <editor
          [apiKey]="editorApiKey"
          [cloudChannel]="'8'"
          [init]="editorConfig"
          style="border: none"
          *ngIf="editorConfig"
          [(ngModel)]="currentFlyCut.text"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
          class="disabled noselect"
        >
        </editor>
      </vng-card>
    </div>
    <div style="display: flex; flex-direction: column; flex: 1 1 100%; max-width: 49%">
      <div style="background-color: #2a1e36; width: 40%; height: 30px">
        <span style="color: #fff; vertical-align: sub; padding-left: 8px">
          {{ prevFlyCut.modified }}
        </span>
      </div>
      <vng-card>
        <div class="preview-fields-row">
          <vng-input
            label="FlyCut"
            placeholder="FlyCut"
            style="flex: 1 1 100%; max-width: 30%"
            type="text"
            [(ngModel)]="prevFlyCut.shortcut"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          ></vng-input>

          <vng-input
            label="Title/Description"
            placeholder="Title/Description"
            style="flex: 1 1 100%; max-width: 70%"
            type="text"
            [(ngModel)]="prevFlyCut.title"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          ></vng-input>
        </div>

        <hr style="width: 100%; margin-left: 0" />
        <editor
          [apiKey]="editorApiKey"
          [cloudChannel]="'8'"
          [init]="editorConfig"
          *ngIf="editorConfig"
          [(ngModel)]="prevFlyCut.text"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
          class="disabled noselect"
        >
        </editor>
      </vng-card>
    </div>
  </div>
  <div class="version-preview-actions">
    <div class="version-preview-actions__spacer"></div>
    <div class="version-preview-actions__buttons">
      <!-- V2-11 residual / V3-04: the outer version-preview Cancel is the last
           member of the Cancel-button family still on the ink-on-white secondary
           variant; master draws it as the orange outline variant, like the nested
           confirm-version and delete-version dialogs already do. -->
      <button class="hide-on-mobile" id="cancel" type="button" vng-button variant="outline" aria-label="cancel" tabindex="-1" (click)="close()">
        Cancel
      </button>

      <button
        class="hide-on-mobile"
        id="deleteShortcut"
        type="button"
        vng-button
        variant="primary"
        aria-label="delete"
        tabindex="-1"
        (click)="confirmVersionDialog()"
      >
        Make Current Version
      </button>
    </div>
  </div>
</div>
